import { render, staticRenderFns } from "./HonorsPage.vue?vue&type=template&id=58acab6a&scoped=true"
import script from "./HonorsPage.vue?vue&type=script&lang=js"
export * from "./HonorsPage.vue?vue&type=script&lang=js"
import style0 from "./HonorsPage.vue?vue&type=style&index=0&id=58acab6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58acab6a",
  null
  
)

export default component.exports